export const data = {
  name: "Bishoy George",
  role: "Frontend Developer",
  tagline: "Curious and creative frontend developer turning ideas into modern, effortless websites.",
  about: [
    "Curiosity drives me, problem-solving defines me — and frontend development is where I turn both into engaging digital experiences.",
    "I'm a Computer Science student at Alexandria University (Faculty of Science, SIM Department) and a DEPI React Frontend graduate, with hands-on experience from 5+ projects.",
    "I specialize in React.js, HTML, CSS, and JavaScript, creating websites that are modern, minimalist, and effortless to use. My ability to blend fresh ideas with proven skills delivers results that excite users and build trust with clients.",
  ],
  education: {
    degree: "B.Sc. in Computer Science",
    dept: "Software Industry & Multimedia (SIM)",
    school: "Faculty of Science, Alexandria University",
    gpa: "3.5 / 4.0",
    status: "Currently Enrolled",
    certification: "DEPI React Frontend Graduate",
    courses: ["MERN Stack Development", "Software Engineering", "Interactive Applications"],
  },
  skills: [
    {
      icon: "⚛️",
      title: "Frontend",
      desc: "Component-driven UIs with React.js, clean semantic HTML & CSS.",
      tags: ["React.js", "HTML5", "CSS3", "JavaScript", "Bootstrap"],
    },
    {
      icon: "🗄️",
      title: "Backend & DB",
      desc: "Full-stack capability across the MERN stack.",
      tags: ["Node.js", "Express.js", "MongoDB"],
    },
    {
      icon: "🎨",
      title: "Design",
      desc: "Minimalist, modern UI adaptable to any brand.",
      tags: ["Responsive Design", "UX Thinking", "Figma"],
    },
    {
      icon: "🔧",
      title: "Tools",
      desc: "Modern dev tooling and version control.",
      tags: ["Git", "GitHub", "VS Code"],
    },
    {
      icon: "🧠",
      title: "Soft Skills",
      desc: "The traits that turn good code into great products.",
      tags: ["Problem Solving", "Curiosity", "Fast Learner"],
    },
    {
      icon: "📚",
      title: "Learning",
      desc: "Deepening full-stack skills via DEPI & university.",
      tags: ["MERN Stack", "Software Engineering"],
    },
  ],
  projects: [
    {
      id: "01",
      title: "Movie-List",
      type: "Web App · Concept",
      desc: "A responsive movie browsing app with search, favorites, and a clean dark UI focusing on smooth user interactions.",
      url: "https://bishoygs.github.io/Movie-List/",
      github: "https://github.com/BishoyGS/Movie-List",
      tech: ["React.js", "HTML5", "CSS3", "JavaScript", "API Integration", "Local Storage"],
      accent: "#7b2fff",
      bg: "linear-gradient(135deg,#0a0020,#200040)",
      abbr: "ML",
    },
    {
      id: "02",
      title: "menu-list",
      type: "Web App · Concept",
      desc: "A responsive menu browsing app with search, favorites, and a clean UI focusing on smooth user interactions.",
      url: "https://bishoygs.github.io/menu-app/",
      github: "https://github.com/BishoyGS/menu-app",
      tech: ["React.js", "HTML5", "CSS3", "JavaScript", "API Integration", "Local Storage"],
      accent: "#3ce04c",
      bg: "linear-gradient(135deg, #16581d, #2e6f37)",
      abbr: "ML",
    },
    {
      id: "03",
      title: "AURA Perfume",
      type: "E-Commerce · Concept",
      desc: "An elegant luxury perfume interface with smooth navigation, product filtering, and brand-first aesthetics. Built with HTML, CSS, Bootstrap & JavaScript.",
      url: "https://bishoygs.github.io/AURA_perfume-/",
      github: "https://github.com/BishoyGS/AURA_perfume-",
      tech: ["HTML5", "CSS3", "Bootstrap", "JavaScript", "Responsive Design"],
      accent: "#c6ff00",
      bg: "linear-gradient(135deg,#1a1a00,#3a3500)",
      abbr: "AU",
    },
    {
      id: "04",
      title: "Social-Accs",
      type: "Link Hub · Concept",
      desc: "A clean, responsive hub that centralizes all social media and professional profiles in one place.",
      url: "https://bishoygs.github.io/bishos_social_accs/",
      github: "https://github.com/BishoyGS/bishos_social_accs",
      tech: ["HTML5", "CSS3", "JavaScript", "Responsive Design"],
      accent: "#00e5ff",
      bg: "linear-gradient(135deg,#00101a,#003d4d)",
      abbr: "SA",
    },
  ],
  contact: {
    email: "bishoygeorge25@gmail.com",
    phone: "+20 1224527000",
    linkedin: "https://www.linkedin.com/in/bishoy-webdev/",
    github: "https://github.com/BishoyGS",
    location: "Alexandria, Egypt",
  },
};
